export const formatDeadline = (deadline: string | number): string => {
  return (
    {
      1: 'Pronta entrega',
      2: '20 dias',
    }[deadline] ?? 'Pronta entrega'
  );
};
